import { User } from "models/user";

export class StartAction {
    constructor(
        public user: User,
        public token: string
    ) {}
}
export class LogoutAction {
    constructor(
        public reason: string = null,
        public redirectToLogin: boolean = true
    ) {}
}
export class RefreshTokenAction {}
